import { render, staticRenderFns } from "./ForcePasswordUpdate.vue?vue&type=template&id=70887987&scoped=true&"
import script from "./ForcePasswordUpdate.vue?vue&type=script&lang=js&"
export * from "./ForcePasswordUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ForcePasswordUpdate.vue?vue&type=style&index=0&id=70887987&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70887987",
  null
  
)

export default component.exports